import siteImg from './site-img.vue';
import siteVideo from './site-video';
import imgBox from './img-box.vue';
import pop from './pop.vue';
import moduleBox from './module-box.vue';
import switchDevice from './switch-device.vue';
import popMgr from './popMgr';
import ImSelect from './select/select';
import ImOption from './select/option';
import ImOptionGroup from './select/option-group';
import ImInput from './input/input.vue';
import ImTag from './tag/tag.vue';
import ImPicker from './m-picker/picker.vue';
import ImCheckbox from './checkbox.vue';
import ImCalendar from './m-calendar/index.vue';
import detailPop from './detail-pop';
import Popper from './popper/popper.vue';
import SchemaInfo from './schemaInfo.vue';
// import ImRow from './im-row/index.vue';
// import ImCol from './im-col/index.vue';
import teleport from './teleport.vue';
export default function (Vue) {
    Vue.component('site-img', siteImg);
    Vue.component('site-video', siteVideo);
    Vue.component('img-box', imgBox);
    Vue.component('pop', pop);
    Vue.component('module-box', moduleBox);
    Vue.component(switchDevice.name, switchDevice);
    Vue.component(ImSelect.name, ImSelect);
    Vue.component(ImOption.name, ImOption);
    Vue.component(ImOptionGroup.name, ImOptionGroup);
    Vue.component(ImInput.name, ImInput);
    Vue.component(ImTag.name, ImTag);
    Vue.component(ImPicker.name, ImPicker);
    Vue.component(ImCheckbox.name, ImCheckbox);
    Vue.component(ImCalendar.name, ImCalendar);
    Vue.component(Popper.name, Popper);
    Vue.component('schema-info', SchemaInfo);

    Vue.component('teleport', teleport);

    // Vue.component(ImRow.name, ImRow);
    // Vue.component(ImCol.name, ImCol);
}

export { popMgr };
export { detailPop };
